import { createFileRoute, redirect } from '@tanstack/react-router';

import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/overview/')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/projects/$projectId/sourcing/overview/$view',
            params: {
                projectId: params.projectId,
                view: 'scenarios',
            },
            replace: true,
        });
    },
});
